import { createFileRoute } from '@tanstack/react-router';

import { SupplyAppsPage } from '../features/campaigns/supply/SupplyAppsPage';
import { supplyRouteSearchSchema } from '../features/campaigns/supply/supplyRouteSearch';

export const Route = createFileRoute('/campaigns/supply/apps')({
  validateSearch: supplyRouteSearchSchema,
  component: SupplyAppsPage,
});
